// @flow
import React, { useEffect, useState } from 'react';

import Loading from 'components/fragments/Loading';
import FidBadgeCard from 'components/profile/Fidelite/fidBadgeCard';
import { STATUS_FAILURE, STATUS_SUCCESS } from 'constants/statusConstants';
import type { FidBadgesType } from 'types/Fid';
import type { Status } from 'types/Status';

export type StateProps = {
  fidBadgesData: FidBadgesType,
  fidBadgesStatus: Status
};

export type DispatchProps = {
  fetchFidBadges: () => void
};

type Props = StateProps & DispatchProps;

function FidExplanationBadges({ fetchFidBadges, fidBadgesData, fidBadgesStatus }: Props) {
  const [isLoading, setIsLoading] = useState(true);
  const [interactionBadges, setInteractionBadges] = useState([]);
  const [transactionnalBadges, setTransactionnalBadges] = useState([]);

  console.log('interactionBadges', interactionBadges);

  useEffect(() => {
    if (
      fidBadgesStatus === STATUS_FAILURE ||
      !fidBadgesData ||
      !!fidBadgesData.fid_badges_error ||
      !fidBadgesData.fid_badges ||
      !fidBadgesData.fid_badges.length
    ) {
      fetchFidBadges();
    }
  }, []);

  useEffect(() => {
    if (fidBadgesStatus === STATUS_SUCCESS) {
      setIsLoading(false);
      getSpecificBadges('transactionnel', setTransactionnalBadges);
      getSpecificBadges('interaction', setInteractionBadges);
    }
  }, [fidBadgesStatus]);

  const getSpecificBadges = (type: 'transactionnel' | 'implication' | 'interaction', setState: Function) => {
    let specificBadges = [];
    if (!!fidBadgesData.fid_badges.length) {
      specificBadges = fidBadgesData.fid_badges.filter(fid_badge => fid_badge.type === type);
    }

    setState(specificBadges);
  };

  if (isLoading) {
    return <Loading isWhite />;
  }

  // !@todo => gérer les erreurs de l'api

  return (
    <div className="fid-modal--explanation-badges">
      <h3 className="mb-3 degrade_fid">Débloquez des badges</h3>

      {!!transactionnalBadges.length && (
        <section className="transactionnal-badges">
          <p>
            Tous les 2 achats (supérieurs à 50€) dans la boutique
            ou la billetterie, déverrouille <strong>un badge</strong>.
          </p>
          {/* Tous les 2 achats (supérieurs à 50€) dans la boutique
            ou la billetterie, déverrouille <strong>un badge</strong> et accède
            à une <strong>surprise exclusive</strong>. */}
          <div className="badge-list">
            {transactionnalBadges.map(badge => (
              <FidBadgeCard key={badge.id_badge} badge={badge} />
            ))}
          </div>
        </section>
      )}

      {// !!transactionnalBadges.length && ( // à décommenter pour test tant qu'on a pas les badges d'interaction
      !!interactionBadges.length && ( // à commenter pour test tant qu'on a pas les badges d'interaction
        <section className="interaction-badges">
          <div className="top" />
          <p>
            Tous les 2 ans d’abonnement à la newsletter (jusqu’à 6 ans), 
            {' '}
            <strong>cumule un badge</strong>.
          </p>
          {/*Tous les 2 ans d’abonnement à la newsletter (jusqu’à 6 ans),
            <strong>cumule un badge</strong> et débloque l’accès à une <strong>surprise exclusive</strong>. */}
          <div className="badge-list">
            {// transactionnalBadges.map(badge => ( // à décommenter pour test tant qu'on a pas les badges d'interaction
             interactionBadges.map( badge => ( // à commenter pour test tant qu'on a pas les badges d'interaction
              <FidBadgeCard key={badge.id_badge} badge={badge} />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}

export default FidExplanationBadges;
